// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101')
];

export const server_loads = [];

export const dictionary = {
		"/": [18],
		"/ai": [19,[2]],
		"/ai/[projectId]": [20,[2,3]],
		"/ai/[projectId]/prompts": [21,[2,3]],
		"/calendar": [22],
		"/calendar/booking-overview": [23],
		"/calendar/send-booking-links": [24],
		"/clients": [25,[4]],
		"/clients/merge": [38,[4]],
		"/clients/[clientId]": [26,[5]],
		"/clients/[clientId]/bookings": [27,[5]],
		"/clients/[clientId]/health-programs": [28,[5]],
		"/clients/[clientId]/healthplan": [29,[5]],
		"/clients/[clientId]/message": [30,[5,6]],
		"/clients/[clientId]/message/conversation": [32,[5,6]],
		"/clients/[clientId]/message/[conversationId]": [31,[5,6]],
		"/clients/[clientId]/notes": [33,[5]],
		"/clients/[clientId]/overview": [34,[5]],
		"/clients/[clientId]/profile": [35,[5]],
		"/clients/[clientId]/testresults": [36,[5]],
		"/clients/[clientId]/testresults/[reportId]": [37,[5]],
		"/companies": [39],
		"/companies/[companyId]/benefits": [40,[7]],
		"/companies/[companyId]/clients": [41,[7]],
		"/companies/[companyId]/health-programs": [42,[7]],
		"/companies/[companyId]/message": [43,[7,8]],
		"/companies/[companyId]/message/[conversationId]": [44,[7,8]],
		"/companies/[companyId]/roles": [45,[7]],
		"/companies/[companyId]/settings": [46,[7]],
		"/companies/[companyId]/tags": [47,[7]],
		"/companies/[companyId]/testphases": [48,[7]],
		"/companies/[companyId]/testphases/[testPhaseId]": [49,[7]],
		"/companies/[companyId]/testphases/[testPhaseId]/billing": [50,[7]],
		"/companies/[companyId]/testphases/[testPhaseId]/booking-block-wizard": [51,[7]],
		"/company-messages": [52,[9]],
		"/company-messages/bulk-messaging": [53,[9]],
		"/company-messages/welcome-message": [54,[9]],
		"/dashboard": [55],
		"/demo": [56,[10]],
		"/demo/[listType]": [57,[10]],
		"/feature-toggle": [58,[11]],
		"/feature-toggle/[featureId]": [59,[11]],
		"/feedbacks": [60],
		"/health-programs": [61],
		"/health-programs/[healthProgramId=integer]": [62,[12]],
		"/health-programs/[listType]": [63],
		"/kpis": [64],
		"/login": [65],
		"/logout": [66],
		"/logs": [67],
		"/message-logs": [68],
		"/messages": [69,[13]],
		"/messages/all": [70,[13]],
		"/messages/bulk-messaging": [71,[13]],
		"/messages/monitored": [72,[13]],
		"/messages/templates": [73,[13]],
		"/notifications": [74],
		"/notifications/[notificationId]": [75],
		"/okr": [76],
		"/org-migration": [77,[14]],
		"/profile": [78],
		"/reauth": [79],
		"/register": [80],
		"/reports/lid-validation": [85,[15]],
		"/reports/merge": [86,[15]],
		"/reports/[reportId=integer]": [81,[16]],
		"/reports/[reportId=integer]/reportinformation": [82,[16]],
		"/reports/[reportId=integer]/survey": [83,[16]],
		"/reports/[reportType]": [84,[15]],
		"/reset-password": [87],
		"/sentry-example-page": [88],
		"/settings": [89],
		"/stats": [90],
		"/styling-test": [91],
		"/testing-tools": [92,[17]],
		"/testing-tools/cron": [93,[17]],
		"/testing-tools/data": [94,[17]],
		"/testing-tools/delete-test-phase": [95,[17]],
		"/testing-tools/emails": [96,[17]],
		"/testing-tools/mu": [97,[17]],
		"/testing-tools/system": [98,[17]],
		"/testing-tools/test-data": [99,[17]],
		"/unauthorized": [100],
		"/users": [101]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);